<template>
  <v-layout
    row
    class="mt-5 mb-4"
  >
    <v-flex
      xs12
      sm8
      offset-sm2
      md8
      offset-md2
      lg8
      offset-lg2
    >
      <v-card flat color="transparent" class="elevation-24">
        <v-card-title
          primary-title
          class="grey lighten-4 pl-4"
        >
          <h3 class="headline mb-0">LokalesHandwerk.de GmbH</h3>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>

          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <p class="title">LokalesHandwerk.de GmbH</p>
                <p class="subheading">Amtsgericht Essen, HRB 29081<br>

                  USt-IdNr.: DE318031778</p>
              </v-flex>

            </v-layout>

            <v-layout row wrap>
              <v-flex
                xs12
                md6
              >
                <v-card flat color="transparent">
                  <v-card-text class="px-0">
                    <p class="title">Martin Weber</p>
                    <p class="subheading">Geschäftsführung</p>

                  </v-card-text>
                </v-card>
                <v-card flat color="transparent">
                  <v-card-text class="px-0">
                    <p class="title">Lars Steinborn</p>
                    <p class="subheading">Technik</p>

                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex
                xs12
                md6
              >
                <v-card flat color="transparent">
                  <v-card-text class="px-0">
                    <p class="title">Adresse</p>
                    <p class="subheading"><strong>Haus des Handwerks</strong><br>

                      Katzenbruchstr. 71<br>
                      45141 Essen
                    </p>

                  </v-card-text>

                  <!-- <v-img
                    contain
                    aspect-ratio
                    max-height="100"
                    src="img/kreishandwerkerschaften.png"
                  ></v-img> -->

                </v-card>
              </v-flex>
              <v-flex
                xs12
                md6
              >
                <v-card flat color="transparent">
                  <v-card-text class="px-0">
                    <p class="title">Kontakt</p>
                    <p class="subheading">

                      <v-btn href="mailto:info@lokaleshandwerk.de">
                        <v-icon left>mail</v-icon>info@lokaleshandwerk.de
                      </v-btn>

                      <!-- <br>
                      <br>
                       <v-btn href="tel:020132008805">
                        <v-icon left>phone</v-icon>0201 / 320 088 05
                      </v-btn> -->
                    </p>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
                <v-flex xs12 md6>
                 <v-card max-width="500" flat color="transparent" class="pl-0 py-2">
                  <v-img
                    aspect-ratio
                    max-height="104"
                    contain
                    position="left"
                    src="img/kreishandwerkerschaften.png"
                  ></v-img>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>

        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  metaInfo () {
    return { title: 'Impressum' }
  }
}
</script>


